const Accordion = ({
    menu = {},
    onSideBarHandler = () => { },
    email = {},
    sideBar = [],
    selectedMailAndCategory,
}) => {
    return (
        <div class="accordion" id="accordionExample">
            <div class="accordion-item ">
                <h2 class="accordion-header ">
                    <button class="accordion-button " style={{ backgroundColor: '#104569'}} type="button" data-bs-toggle="collapse" data-bs-target={`#${email?.id}`} aria-expanded="true" aria-controls={`${email?.id}`}>
                        <div
                            className="d-flex column-gap-2 py-2 w-75 overflow-hidden fs-4 fw-bold emailWrapper "
                            onClick={() => { }}
                        >
                            <p
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={menu?.name}
                                className="m-0 text-white">
                                {email?.email?.length > 20 ? email?.email.slice(0, 20) + '...' : email?.email}
                            </p>
                        </div>
                    </button>
                </h2>
                <div id={`${email?.id}`} class="accordion-collapse collapse show" >
                    <div class="accordion-body">
                        {
                            sideBar.map((menu) => {
                                let count = 0

                                if (menu?.id === 'inbox') {
                                    count = email?.inbox
                                } else if (menu?.id === 'sent') {
                                    count = email?.sent
                                } else if (menu?.id === 'drafts') {
                                    count = email?.drafts
                                } else {
                                    count = email?.junk
                                }

                                return (
                                    <div
                                        key={menu?.id}
                                        className={`d-flex m-0 column-gap-4 justify-content-between px-4 py-1   `}
                                        style={{
                                            cursor: 'pointer',
                                            borderRadius: 5,
                                            backgroundColor: `${(email?.email === selectedMailAndCategory?.email && menu?.id === selectedMailAndCategory?.category) ? '#E9EEF8' : ''}`,
                                            color: `${(email?.email === selectedMailAndCategory?.email && menu?.id === selectedMailAndCategory?.category) ? '#104569' : '#104569'}`
                                        }} >
                                        <div
                                            className="d-flex column-gap-2 py-2 w-75 overflow-hidden fs-4 fw-bold emailWrapper"
                                            onClick={() => { onSideBarHandler(email?.email, menu, email?.domain) }}
                                        >
                                            <p
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title={menu?.name}
                                                className="m-0">
                                                {menu?.name}
                                            </p>
                                        </div>
                                        <p
                                            className="m-0 d-flex align-items-center fs-4 "
                                            style={{ color: `${(email?.email === selectedMailAndCategory?.email && menu?.id === selectedMailAndCategory?.category) ? '#104569' : '#104569'}` }}
                                        >
                                            {count || 0}
                                        </p>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Accordion